<template>
  <div class="doc-accordion">
    <button
      type="button"
      class="doc-accordion__header"
      :aria-expanded="String(isOpen)"
      @click="isOpen = !isOpen"
    >
      <span>{{ title }}</span>
      <span class="doc-accordion__caret" :class="{ 'doc-accordion__caret--open': isOpen }" />
    </button>
    <div v-if="isOpen" class="doc-accordion__body">
      <slot />
    </div>
  </div>
</template>

<script>
// A collapsible docs section (closed by default). Never submits a surrounding form.
export default {
  name: 'DocAccordion',
  props: {
    title: { type: String, required: true },
    open: { type: Boolean, default: false }
  },
  data() {
    return { isOpen: this.open }
  }
}
</script>

<style>
.doc-accordion {
  margin-top: 1.5rem;
  border: 1px solid #dee2e6;
}

.doc-accordion__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
  border: 0;
  background: var(--gray-100);
  color: #000;
  font-weight: 700;
  text-align: left;
}

.doc-accordion__caret {
  border-top: 0.35em solid;
  border-right: 0.35em solid transparent;
  border-left: 0.35em solid transparent;
  transition: transform 0.15s;
}

.doc-accordion__caret--open {
  transform: rotate(180deg);
}

.doc-accordion__body {
  padding: 0 1rem 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Docs/DocAccordion.vue